'use client';

import { useState, useCallback } from 'react';
import { adminKycApi } from '../api';
import { DocumentReviewResponse } from '../types';

interface UseRejectDocumentReturn {
  reject: (documentId: string, tenantSlug: string, rejectionReason: string, adminUserId?: string) => Promise<DocumentReviewResponse>;
  isLoading: boolean;
  error: string | null;
  data: DocumentReviewResponse | null;
  reset: () => void;
}

export function useRejectDocument(): UseRejectDocumentReturn {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [data, setData] = useState<DocumentReviewResponse | null>(null);

  const reject = useCallback(
    async (documentId: string, tenantSlug: string, rejectionReason: string, adminUserId?: string) => {
      setIsLoading(true);
      setError(null);
      setData(null);
      try {
        const response = await adminKycApi.rejectDocument(documentId, tenantSlug, rejectionReason, adminUserId);
        setData(response);
        return response;
      } catch (err) {
        const errorMessage = err instanceof Error ? err.message : 'Failed to reject document';
        setError(errorMessage);
        throw err;
      } finally {
        setIsLoading(false);
      }
    },
    []
  );

  const reset = useCallback(() => {
    setIsLoading(false);
    setError(null);
    setData(null);
  }, []);

  return { isLoading, error, data, reject, reset };
}
